import axios from 'axios';
import store from '../redux/store/store';
const userToken = store.getState()?.auth?.user?.accessToken?.token;
const attributeService = {
 
  fetchAttribute: async (userId,token) => {
    try {
      const response = await axios.get('/Attribute', {
        params: {
          isGroupName:true,
          UserId: userId,
        },
        headers:{
          Authorization: `Bearer ${userToken}`
        }
      });
      return response?.data;
    } catch (error) {
      console.error('Error fetching invoices:', error);
      throw error;
    }
  },
 
}
export default attributeService;
